export default "__VITE_ASSET__CJ8xp3j3__"